var Observable_1 = require('../../Observable');
var subscribeOn_1 = require('../../operator/subscribeOn');
Observable_1.Observable.prototype.subscribeOn = subscribeOn_1.subscribeOn;
//# sourceMappingURL=subscribeOn.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/subscribeOn.js
 ** module id = 409
 ** module chunks = 1
 **/